import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    updateStatus: 'Edit status',
  },
  fr: {
    updateStatus: 'Changer le statut',
  },
} as const);
